<template>
  <div class="editPage">
    <qx-card :title="'证件登记信息'">
      <BaseForm ref="baseForm" @plateNumberChange="plateNumberChange" @vehicleForm="vehicleForm"/>
      <ReviewInfo ref="reviewInfoForm" @drivingLicenseForm="drivingLicenseForm"/>
    </qx-card>
    <SubBtnBox @sub="sub" v-if="$route.query.type !== 'detail'" />
  </div>
</template>

<script>
import BaseForm from './base';
import ReviewInfo from './reviewInfo';
import SubBtnBox from 'components/subBtnBox';
import {
  getVehicleCertificatesInsurance,
  doSaveVehicleCertificatesInsurance,
} from 'api/car';
// import {
//   getEnumList,
// } from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    ReviewInfo,
    SubBtnBox,
  },
  data () {
    return {
      vehicleInfo: '',
      drivingLicenseInfo: '',
      pageUrl: '/manage/car/maintain/review/edit',
      formComponents: [
        'baseForm',
        'reviewInfoForm',
      ],
      editParams: {
        busiType: 2,
      },

      // 需要对比的参数
      compareParams: {
        vehicle: {},

        insuranceStartDate: '',
        insuranceEndDate: '',
        registrantionTime: '',
        drivingLicenseDate: '',
        certificatesInsuranceFee: '',
        insuranceCompany: '',
        picList: [],
      },
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: getVehicleCertificatesInsurance,
    editApi: doSaveVehicleCertificatesInsurance,
    async handleSubSucc (res) {
      if (res && res.code && res.code === 200) {
        if (this.drivingLicenseInfo) {
          await doSaveVehicleCertificatesInsurance({
            busiType: 2,
            ...this.vehicleInfo, ...this.drivingLicenseInfo,
          });
          if (res && res.code && res.code === 200) {
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.close();
          }
        } else {
          if (res && res.code && res.code === 200) {
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.close();
          }
        }
      }

    },
    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (Object.keys(compareParams.vehicle)) {
        compareParams.plateNumber = compareParams.vehicle.plateNumber;
      }
      compareParams.insuranceStartDate = this.formatDate(compareParams.insuranceStartDate);
      compareParams.insuranceEndDate = this.formatDate(compareParams.insuranceEndDate);
      compareParams.registrantionTime = this.formatDate(compareParams.registrantionTime);
      compareParams.drivingLicenseDate = this.formatDate(compareParams.drivingLicenseDate);

      if (compareParams.picList.length) {
        compareParams.picFileIds = (compareParams.picList.map((item) => item.fileId)).join(',');
      } else {
        compareParams.picFileIds = '';
      }
    },
    plateNumberChange (plateNumberInfo) {
      this.$refs.reviewInfoForm.setReviewFormVal(plateNumberInfo);
    },
    vehicleForm (vehicleInfo) {
      this.vehicleInfo = vehicleInfo;
    },
    drivingLicenseForm (drivingLicenseInfo) {
      this.drivingLicenseInfo = drivingLicenseInfo;
    },

  },
  async mounted () {
    this.getData();

  },
};
</script>

<style>
</style>
